import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding-left: ', 'px;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding-left: ', 'px;\n']);

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';

var gridSizeUnitless = gridSize();

export default styled.span(_templateObject, gridSizeUnitless / 2);